import {
   IconFillColor,
   IconSize,
   IconWrapper,
   QuestionmarkCircleIcon,
   StyledFlex,
   Tooltip,
   TooltipLabel,
} from '@dreryk/react-components';

import { invoiceCreateModalTranslationKeys } from '../../../translations';

type InvoiceItemsTableMedicalServiceNameCellTooltipProps = {
   readonly name: string | number;
   readonly nameForInvoicing: string | null;
};

export const InvoiceItemsTableMedicalServiceNameCellTooltip = (
   props: InvoiceItemsTableMedicalServiceNameCellTooltipProps
): JSX.Element => {
   return (
      <StyledFlex justifyContent={'center'} alignItems={'center'} gap={4}>
         <Tooltip
            maxWidth={'400px'}
            testId={'medicalServiceNameTooltip'}
            content={
               <div>
                  <TooltipLabel label={invoiceCreateModalTranslationKeys.table.medicalServiceNameTooltip} />
                  {props.name}
               </div>
            }
         >
            <IconWrapper
               testId={'medicalServiceNameTooltipIconWrapper'}
               fillColor={IconFillColor.PRIMARY}
               size={IconSize.SMALL}
            >
               <QuestionmarkCircleIcon />
            </IconWrapper>
         </Tooltip>
         <span>{props.nameForInvoicing ?? props.name}</span>
      </StyledFlex>
   );
};
